// Which browser this build is for, and whether it runs on a phone or tablet.
// Pure: the background, the popup and the content script all ask it.
//
// The browser is decided at build time (BUILD_TARGET=safari, see SAFARI.md),
// not sniffed, so a Chrome build can never take a Safari branch. Tests run
// without one and get Chrome.
export const CHROME = "chrome";
export const SAFARI = "safari";

export function getBrowser() {
  return process.env.BROWSER === SAFARI ? SAFARI : CHROME;
}

export function isSafari() {
  return getBrowser() === SAFARI;
}

// iPhone, iPod, and iPad. An iPad asks for desktop sites by default and says
// it is a Mac, so it is told apart by its touch screen.
export function isAppleMobile(nav = globalThis.navigator) {
  if (!nav) return false;
  const userAgent = nav.userAgent || "";
  if (/\b(iPhone|iPad|iPod)\b/.test(userAgent)) return true;
  return /\bMacintosh\b/.test(userAgent) && Number(nav.maxTouchPoints) > 1;
}

// Mobile Safari: the Safari build, on an iPhone or iPad. No windows, no
// keyboard shortcuts, and the popup opens as a sheet the width of the screen.
export function isMobileSafari(nav = globalThis.navigator) {
  return isSafari() && isAppleMobile(nav);
}
